import { render } from "./completed-trips-card.vue?vue&type=template&id=5886f2ef&scoped=true"
import script from "./completed-trips-card.vue?vue&type=script&lang=js"
export * from "./completed-trips-card.vue?vue&type=script&lang=js"

import "./completed-trips-card.vue?vue&type=style&index=0&id=5886f2ef&scoped=true&lang=css"

import exportComponent from "/home/runner/work/provider-frontend/provider-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5886f2ef"]])

export default __exports__